import guaranteeCard from 'pages/guaranteeCard'

export default [
    { path: '/guarantee-cards/:id', name: 'guaranteeCard.edit', component: guaranteeCard,
    meta:{permits:['guarantee_card_list']}},
]